import { Injectable } from '@angular/core';
import { IDropdownOption } from '../../../../../projects/shared/nvps-libraries/design/interfaces/design-library.interface';
import { TValidMockRegentsReports } from '../../constants/pdf-reports.constant';

@Injectable()
export class MockRegentsService {
  constructor () {};

  public setMockRegentsOption (
    reportOptions: Array<IDropdownOption>,
    currentExam: string,
    mockExamName: string,
  ): Array<IDropdownOption> {
    const examKeySuffix = currentExam.replace('mockRegents_', '');

    const newMockOption = {
      reportFileName: `mockRegents_[${examKeySuffix}]`,
      key: currentExam,
      human: mockExamName,
      pillPlaceholder: `${mockExamName} Mock Regent`,
      exportFileNameSuffix: examKeySuffix,
    };

    return reportOptions.map((option) => {
      if (option.key === 'mockRegents') {
        return {
          ...option,
          options: [newMockOption],
        };
      }
      return option;
    });
  }
}
